import React, { useEffect, useState } from "react"; // Ensure React is imported correctly
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { PeriodProvider } from 'components/PeriodContext'; // Import PeriodProvider
import { doc, getDoc } from 'firebase/firestore';
import { db } from 'firebaseConfig';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BacktestingPlaceholder from "components/BacktestingPlaceholder";
import FXBacktesting from '../../components v2/FXBacktesting_v2';

const Backtesting_v2 = ({ userID, initialCapital, userData }) => {
  const [isDemo, setIsDemo] = useState(false);
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    
    // Keep auth state listener
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("User is signed in with UID:", user.uid);
        setAuthUser(user);
        
        // Fetch demo status when user is authenticated
        try {
          const userDoc = await getDoc(doc(db, 'Users', user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setIsDemo(userData.isDemo || false);
            console.log("User demo status:", userData.isDemo);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        console.log("User is signed out");
        setAuthUser(null);
        setIsDemo(false);
      }
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <PeriodProvider>
          <MDBox mb={3}>
            <FXBacktesting 
              userID={userID} 
              userData={userData} 
              isDemo={isDemo}
            />
          </MDBox>
        </PeriodProvider>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

Backtesting_v2.propTypes = {
  userID: PropTypes.string.isRequired,
  initialCapital: PropTypes.number,
  userData: PropTypes.object,
};

export default Backtesting_v2;
